module.exports = __webpack_public_path__ + "img/icon-04.22f075a5.png";